// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-group-infos[data-v-14ad3b14]{background-color:#d3d3d3}", ""]);
// Exports
module.exports = exports;
